import { ICacheKeyInputs } from './types';

export const createCacheKey = (keyData: ICacheKeyInputs): string | null => {
    const { chromeStyleId, vin, dealerId, financeListedPrice, leaseListedPrice, sponsor } = keyData;

    if ((!chromeStyleId && !vin) || !dealerId || !financeListedPrice || !leaseListedPrice) {
        return null;
    }

    let sponsorType = 'website';
    // this accounts for empty sponsor, which is valid and should result in 'website'
    if (sponsor && sponsor.toUpperCase() !== 'DDC') {
        sponsorType = 'listing';
    }

    const elements: any[] = ['payment'];
    // Default to use the chromeStyleId in the key if given, otherwise use the vin
    if (vin) {
        elements.push('vin', vin);
    }

    if (chromeStyleId) {
        elements.push('chromeId', chromeStyleId);
    }
    elements.push('dealerId', dealerId);
    elements.push('sponsor', sponsorType);
    elements.push('finance', financeListedPrice);
    elements.push('lease', leaseListedPrice);

    return elements.join('_');
};
